import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

const EmptyListFilter = (props: any) => {
  const theme = useContext(ThemeContext);
  return (
    <svg width="216" height="156" viewBox="0 0 216 156" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="95" cy="70" r="70" fill={theme.colors.selection} />
      <g filter="url(#filter0_d_1170_4373)">
        <rect x="22" y="14" width="145" height="44" rx="4.79339" fill="white" />
        <rect x="22" y="14" width="145" height="44" rx="4.79339" fill="url(#paint0_linear_1170_4373)" />
        <rect
          x="22.3651"
          y="14.3651"
          width="144.27"
          height="43.2698"
          rx="4.42827"
          stroke="#F4F4F4"
          stroke-width="0.730243"
        />
      </g>
      <rect opacity="0.7" x="66" y="32" width="84" height="7" rx="3.5" fill="url(#paint1_linear_1170_4373)" />
      <rect opacity="0.1" x="32" y="24" width="24" height="24" rx="4" fill={theme.colors.primary.c500} />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M51 36C51 39.866 47.866 43 44 43C40.134 43 37 39.866 37 36C37 32.134 40.134 29 44 29C47.866 29 51 32.134 51 36ZM42 34H46V38H42V34Z"
        fill="url(#paint2_linear_1170_4373)"
      />
      <g filter="url(#filter1_d_1170_4373)">
        <rect x="22" y="66" width="145" height="44" rx="4.79339" fill="white" />
        <rect x="22" y="66" width="145" height="44" rx="4.79339" fill="url(#paint3_linear_1170_4373)" />
        <rect
          x="22.3651"
          y="66.3651"
          width="144.27"
          height="43.2698"
          rx="4.42827"
          stroke="#F4F4F4"
          stroke-width="0.730243"
        />
      </g>
      <rect opacity="0.7" x="66" y="84" width="84" height="7" rx="3.5" fill="url(#paint4_linear_1170_4373)" />
      <rect opacity="0.1" x="32" y="76" width="24" height="24" rx="4" fill={theme.colors.primary.c500} />
      <path
        d="M44 95C47.866 95 51 91.866 51 88C51 84.134 47.866 81 44 81C40.134 81 37 84.134 37 88C37 91.866 40.134 95 44 95Z"
        fill="url(#paint5_linear_1170_4373)"
      />
      <path
        d="M44 82C45.876 83.643 46.9421 85.7752 47 88C46.9421 90.2248 45.876 92.357 44 94C42.124 92.357 41.0579 90.2248 41 88C41.0579 85.7752 42.124 83.643 44 82Z"
        stroke={theme.colors.neutrals.white}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38 88C38 88 41.6487 88.5 44 88.5C46.3513 88.5 50 88 50 88"
        stroke={theme.colors.neutrals.white}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g filter="url(#filter2_d_1170_4373)">
        <circle cx="158" cy="105" r="23" fill="url(#paint6_linear_1170_4373)" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M164 95C162.895 95 162 95.8954 162 97V112C162 113.105 162.895 114 164 114H165C166.105 114 167 113.105 167 112V97C167 95.8954 166.105 95 165 95H164ZM155 102C155 100.895 155.895 100 157 100H158C159.105 100 160 100.895 160 102V112C160 113.105 159.105 114 158 114H157C155.895 114 155 113.105 155 112V102ZM148 107C148 105.895 148.895 105 150 105H151C152.105 105 153 105.895 153 107V112C153 113.105 152.105 114 151 114H150C148.895 114 148 113.105 148 112V107Z"
        fill="url(#paint7_linear_1170_4373)"
      />
      <defs>
        <filter
          id="filter0_d_1170_4373"
          x="0.429752"
          y="3.21488"
          width="188.14"
          height="87.1405"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10.7851" />
          <feGaussianBlur stdDeviation="10.7851" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.704 0 0 0 0 0.7552 0 0 0 0 0.8 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1170_4373" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1170_4373" result="shape" />
        </filter>
        <filter
          id="filter1_d_1170_4373"
          x="0.429752"
          y="55.2149"
          width="188.14"
          height="87.1405"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10.7851" />
          <feGaussianBlur stdDeviation="10.7851" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.704 0 0 0 0 0.7552 0 0 0 0 0.8 0 0 0 0.16 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1170_4373" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1170_4373" result="shape" />
        </filter>
        <filter
          id="filter2_d_1170_4373"
          x="100.652"
          y="61.3913"
          width="114.696"
          height="114.696"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="13.7392" />
          <feGaussianBlur stdDeviation="17.1739" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.114792 0 0 0 0 0.258462 0 0 0 0 0.3625 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1170_4373" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1170_4373" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_1170_4373"
          x1="61.7356"
          y1="51.4423"
          x2="66.2666"
          y2="11.335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1170_4373"
          x1="64.6667"
          y1="38.4167"
          x2="158.046"
          y2="22.5223"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={theme.colors.primary.c500} />
          <stop offset="1" stop-color={theme.colors.primary.c500} stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1170_4373"
          x1="49.8337"
          y1="42.8261"
          x2="51.4836"
          y2="26.4289"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={theme.colors.primary.c500} />
          <stop offset="1" stop-color={theme.colors.primary.c500} stop-opacity="0" />
          <stop offset="1" stop-color={theme.colors.primary.c500} stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1170_4373"
          x1="61.7356"
          y1="103.442"
          x2="66.2666"
          y2="63.335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1170_4373"
          x1="64.6667"
          y1="90.4167"
          x2="158.046"
          y2="74.5223"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={theme.colors.primary.c500} />
          <stop offset="1" stop-color={theme.colors.primary.c500} stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1170_4373"
          x1="49.8337"
          y1="94.8261"
          x2="51.4836"
          y2="78.4289"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={theme.colors.primary.c500} />
          <stop offset="1" stop-color={theme.colors.primary.c500} stop-opacity="0" />
          <stop offset="1" stop-color={theme.colors.primary.c500} stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1170_4373"
          x1="135.66"
          y1="103.193"
          x2="167.533"
          y2="124.606"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color={theme.colors.primary.c500} />
          <stop offset="1" stop-color={theme.colors.primary.c400} />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1170_4373"
          x1="152"
          y1="99.5"
          x2="168.695"
          y2="116.871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0.8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default EmptyListFilter;
